import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	OnDestroy,
} from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { map } from "rxjs/operators";
import { IndirizzoDTO } from "../../../models/indirizzo-dto";
import { ComponentOutputStatus } from "../../../normalizzazione/component-output-status";
import { MessageService } from "../../../services/message.service";
import { TerritorioService } from "../../../services/territorio/territorio-service";
import { LocalitaDTO } from "../../../models/localita-dto";
import { StradaDTO } from "../../../models/strada-dto";
import { Nazione } from "../../../models/portale/nazione";

@Component({
	selector: "lib-indirizzo-estero",
	templateUrl: "./indirizzo-estero.component.html",
	styleUrls: ["./indirizzo-estero.component.css"],
})
export class IndirizzoEsteroComponent implements OnInit, OnDestroy {

	@Input()
	indirizzo: IndirizzoDTO;

	nazioni: Observable<Array<Nazione>>;

	@Output()
	done: EventEmitter<ComponentOutputStatus<IndirizzoDTO>> = new EventEmitter<
		ComponentOutputStatus<IndirizzoDTO>
	>();

	form: FormGroup;

	subscription: Subscription;

	constructor(
		private msg: MessageService,
		private territorioService: TerritorioService
	) {
		this.nazioni = territorioService.getNazioni$();
	}

	ngOnDestroy(): void {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}

	ngOnInit() {
		this.form = new FormGroup({});
		let valid = true;
		if (!this.indirizzo) {
			this.indirizzo = new IndirizzoDTO();
			this.indirizzo.localita = new LocalitaDTO();
			this.indirizzo.strada = new StradaDTO();
			valid = false;
		}

		const indirizzo = new FormControl(
			{ value: this.indirizzo.strada.inidirizzo, disabled: false },
			[Validators.required, Validators.maxLength(50)]
		);
		this.form.addControl("indirizzo", indirizzo);

		// const zip = new FormControl(
		//   {value: this.indirizzo.localita.cap, disabled: false}, [Validators.required]
		// );
		// this.form.addControl('zip', zip);

		const nazioni = new FormControl(
			{ value: this.indirizzo.localita.comune, disabled: false },
			[Validators.required]
		);
		this.form.addControl("nazioni", nazioni);

		const changes$ = this.form.valueChanges.pipe(
			map((_) => {
				const localita = new LocalitaDTO();
				// localita.cap = zip.value;
				localita.provincia = "EE";
				localita.comune = nazioni.value;

				const strada = new StradaDTO();
				strada.inidirizzo = indirizzo.value;

				const indirizzoMapped = new IndirizzoDTO();
				indirizzoMapped.localita = localita;
				indirizzoMapped.strada = strada;

				return ComponentOutputStatus.of(this.form.valid, indirizzoMapped);
			})
		);

		this.subscription = changes$.subscribe((_) => this.done.emit(_));
	}
}
